import styled from "@emotion/styled";
import { Col } from "antd";
import { genericStyles } from "../../../constant";

export const StyledTenantFlow = styled(Col)`
  display: flex;
  flex-direction: column;
  height: 100%;
  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 10px;
    letter-spacing: 1px;
  }
  .tenant-details {
    padding: 20px;
    .tenant-header {
      gap: 10px;
      margin-bottom: 10px;
      h4 {
        margin: 0;
      }
      .tenant-avatar {
        width: 56px;
        height: 56px;
        border-radius: 12px;
        background: #f2f3f5;
        flex-shrink: 0;
        color: #333;
        border: 1px solid #e0e0e0;
        img {
          height: 51px;
          width: 51px;
          border-radius: 12px;
        }
      }
      .contact-item {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        color: var(--primary);
        margin-top: 3px;
        a {
          color: var(--primary);
        }
      }
    }

    .branch-details {
      margin-top: 10px;
      border-radius: 10px;
      margin-bottom: 10px;

      .branch-detail-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 0;
        border-bottom: 1px solid #e5e7eb;
      }

      .branch-detail-item:last-child {
        border-bottom: none;
      }

      .branch-detail-icon {
        color: var(--primary);
        font-size: 16px;
      }

      .branch-detail-text {
        font-size: 13px;
        color: #374151;
      }
    }

    .topics-container {
      display: flex;
      gap: 8px;
      overflow-x: auto;
      .topic-chip {
        padding: 6px 14px;
        border-radius: 12px;
        border: 1px solid #d1d5db;
        color: #374151;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.2s ease;
        min-width: fit-content;

        &.disabled {
          cursor: not-allowed !important;
          pointer-events: none;
          opacity: 0.6;
        }

        &:hover,
        &.active {
          background: #eff6ff;
          border-color: var(--primary);
          color: #1e3a8a;
          font-weight: 600;
        }
      }
    }

    hr {
      margin: 20px 0px 0px 0px;
    }
    .create-conv {
      font-size: 22px;
    }
  }
  .left-panel {
    flex: 1;
    height: 100%;
    overflow: auto;
    padding: 0px 20px 20px 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .ticket-badge {
      color: #6b7280;
      font-size: 12px;
    }
    .topic-label {
      background: #f3f4f6;
      color: #374151;
      font-size: 11px;
      padding: 3px 8px;
      border-radius: 4px;
    }

    .panel-header {
      flex-shrink: 0;
      .panel-title {
        margin-bottom: 16px;
      }
      h3 {
        font-size: 18px;
        font-weight: 500;
      }
    }

    .chat-container {
      overflow: auto;
      flex: 1;
      overflow-y: auto;

      .conversation-card {
        padding: 10px 5px;
        cursor: pointer;
        transition: all 0.2s;
        display: flex;
        gap: 12px;
        border-radius: 5px;
        margin-bottom: 8px;

        &:hover {
          background: #f9fafb;
        }

        &.selected {
          background: var(--selected);
          border-left: 4px solid ${genericStyles.primaryColor};
        }

        .avatar-section {
          position: relative;
          margin-top: 7px;
          flex-shrink: 0;
        }

        .card-content {
          flex: 1;
          min-width: 0;
        }

        .card-top {
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          margin-bottom: 6px;
        }

        .customer-name {
          color: #111827;
          font-weight: 500;
          font-size: 15px;
        }

        .timestamp {
          color: #6b7280;
          font-size: 11px;
          margin-left: 6px;
          white-space: nowrap;
        }

        .card-middle {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
          margin-bottom: 7px;
          flex-wrap: wrap;
        }
        .last-message {
          color: #1f2937e4;
          font-size: 13px;
          font-weight: 400;
          max-width: 240px;
          line-height: 1.4;
        }

        .card-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .ant-tag {
          margin: 0;
          font-size: 11px;
          padding: 0px 5px;
          border-radius: 4px;
          background: #f3f4f6;
          color: #374151;
          border: none;
        }
      }
    }
  }
`;
